module.exports = __webpack_public_path__ + "static/media/logo_baovietbank.aa45ab69.svg";